import { Box, Button, Grid, Pagination } from "@mui/material";
import { set } from "date-fns";
import { useContext, useEffect, useState } from "react";
import { useQuery } from "react-query";

import { getProperties } from "../../api/properties/getProperties";
import TokenContext from "../../context/Token";
import { defaultFilter } from "../GeneralFilter/defaultFilter";
import GeneralFilter from "../GeneralFilter/GeneralFilter";
import Loading from "../loading/Loading";
import Table from "../Table/Table";

const { REACT_APP_BASE_URL } = process.env;
// import ProceedingCard from '../../components/Proceeding/ProceedingCard'

const ExpedienteContainer = ({ setStatus }) => {
  const { token } = useContext(TokenContext);
  const [filters, setFilters] = useState({ ...defaultFilter });
  const [settlements, setSettlements] = useState([]);
  const [results] = useState(20);
  const [page, setPage] = useState(1);
  const [paginationValue, setPaginationValue] = useState(1);
  const { isLoading, isError, data, refetch, isFetching } = useQuery(
    ["expediente-properties", results, page],
    () =>
      getProperties(token, results, page, "Expediente", "", "", {
        ...filters,
        dateStart: set(new Date(filters.dateStart), {
          hours: 0,
          minutes: 0,
          seconds: 0
        }).toISOString(),
        dateEnd: set(new Date(filters.dateEnd), {
          hours: 23,
          minutes: 59,
          seconds: 59
        }).toISOString()
      }),
    { refetchOnWindowFocus: false, keepPreviousData: true }
  );

  useEffect(() => {
    const getPaginationValue = () => {
      setPaginationValue(Math.ceil(data?.properties?.totalDocs / results));
    };

    getPaginationValue();
  }, [data?.properties?.totalDocs, results]);

  // if (isLoading) return <Loading />;

  if (isError) {
    return <h2>Error al cargar datos</h2>;
  }

  return (
    <>
      <Box mt={2} height={32}>
        {paginationValue > 0 && (
          <Pagination
            color="primary"
            count={paginationValue}
            page={page}
            onChange={(e, value) => setPage(value)}
          />
        )}
      </Box>
      <a
        className="mt-4"
        href={`${REACT_APP_BASE_URL}/csv/properties?status=Expediente`}
      >
        <Button variant="contained">Descargar CSV</Button>
      </a>
      <Box style={{ width: "100%", paddingLeft: "8px" }} display="flex">
        <GeneralFilter
          refetch={refetch}
          filters={filters}
          setFilters={setFilters}
          settlements={settlements}
          setSettlements={setSettlements}
        />
      </Box>
      {data?.properties.length === 0 ? (
        <h2 className="fs-5 margin-element">
          No se encontraron casas en Clientes
        </h2>
      ) : isFetching ? (
        <Grid
          container
          sx={{ flexGrow: 1 }}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <Grid item>
            <Loading />
          </Grid>
        </Grid>
      ) : (
        <Table
          columnTitles={[
            "ID de la Casa",
            "Precio",
            "Informacion del Cliente",
            "Informacion del Inmueble",
            "Fuente",
            "Acciones"
          ]}
          properties={data?.properties?.docs ?? []}
          refetchProperties={refetch}
          tableType={"Expediente"}
        />
      )}
      {/* {data?.properties?.map(property => (
        <ProceedingCard key={property._id} setStatus={setStatus} property={property} refetchProperties={refetch} />

      ))} */}
    </>
  );
};

export default ExpedienteContainer;
